import { ModelFileTypes } from "@/typed/ModelFileTypes";
import { ThumbnailFileTypes } from "@/typed/ThumbnailFileTypes";

export const getFileTypeFromS3URL = (url: string | undefined): ModelFileTypes | ThumbnailFileTypes | undefined => {
  if (url === undefined) {
    return undefined;
  }
  // Extract the file extension from the URL
  const fileExtension = url.split(".").pop()?.split("?")[0];

  // Check if the file extension is "stl" or "ply"
  if (fileExtension === "stl") {
    return "stl" as ModelFileTypes;
  } else if (fileExtension === "ply") {
    return "ply" as ModelFileTypes;
  } else if (fileExtension === "svg") {
    return "svg" as ThumbnailFileTypes;
  } else if (fileExtension === "png") {
    return "png" as ThumbnailFileTypes;
  }

  // If it's neither, return undefined
  return undefined;
};
